import { render, staticRenderFns } from "./form-action.vue?vue&type=template&id=670a3b98&scoped=true"
import script from "./form-action.vue?vue&type=script&lang=js"
export * from "./form-action.vue?vue&type=script&lang=js"
import style0 from "./form-action.vue?vue&type=style&index=0&id=670a3b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a3b98",
  null
  
)

export default component.exports